import 'styled-components/macro';
import React from 'react';
import { useTheme, Typography } from '@harver/shared-ui';

import { CalendarSearchIcon } from '../../icons';

export function Loader() {
    const theme = useTheme();

    return (
        <div css={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div css={{ margin: `${theme.sizes.xxxLarge} 0 ${theme.sizes.xLarge}` }}>
                <CalendarSearchIcon />
            </div>

            <Typography
                testId="loader.title"
                variant="h2"
                css={{
                    marginBottom: theme.sizes.large,
                    textAlign: 'center',
                    padding: `0 ${theme.sizes.xxLarge}`,
                }}
            >
                Finding available timeslots…
            </Typography>

            <Typography variant="subtitle1" css={{ textAlign: 'center', padding: `0 ${theme.sizes.xLarge}` }}>
                Please wait while we are checking our recruiters calendars.
            </Typography>
            <Typography variant="subtitle1">This may take few moments.</Typography>
        </div>
    );
}
